function loadPlayer(mediaInfo){
	var playerConfig = new SaranyuInstaPlayer(mediaInfo.type, '.instaPlayer', {
		'type': 'Video',
		'content': 'VOD',
		'file': [{
		'content_url': mediaInfo.contenturl,
		'encryption': 'undefined' == mediaInfo.encryption ? false : mediaInfo.encryption,
		// 'encryption': true,
		'drm': {
			'widevine': {
			'LA_URL': 	'undefined' == mediaInfo.laurl ? '' : mediaInfo.laurl
			},
			'fairplay': {
			'CERT_URL': 'undefined' == mediaInfo.certificate ? '' : mediaInfo.certificate,
			'LA_URL': 	'undefined' == mediaInfo.laurl ? '' : mediaInfo.laurl
			}
		},
		// 'npawObj': mediaInfo.npawObj,
		'label': '',
		'mediaid': '1A2B3C4D',
		'videotitle': mediaInfo.title,
		'poster': mediaInfo.poster,
		'seekonload': Number(mediaInfo.seekonload),
		'advisoryValue': mediaInfo.advisoryValue,
		'advisory': {
			'title': mediaInfo.advisory.title,
			'desc': mediaInfo.advisory.desc,
			'start': 0,
			'end': 5
		}
		}],
		'autoplay': eval(mediaInfo.autoplay),
		'mute': false,
		'hideControlsWhenInactive': true,
		'hideControlsTimeout': 5000,
		'nextEpisode': false,
		'prevEpisode': mediaInfo.enablePrevEpisode,
		'qualityswitch': {
		'label': 'auto',
		'metric': 'resolution'
		},
		'advertisement': mediaInfo.adConfig,
		'features': ['pip', 'backbutton', 'title', 'advisory', 'playpause', 'backwardSeek', 'forwardSeek', 'bigicons', 'progressbar', 'volume', 'time', 'cast', 'eventcallbacks', 'PrvEpisode', 'NxtEpisode', 'subtitles', 'multiaudio', 'qualityswitch', 'fullscreen', 'encryption', 'loadcallbacks','advertisement'],
		'heartBeat': {
		'catalogID': 	mediaInfo.catalog_id,
		'contentID': 	mediaInfo.content_id,
		'region': 		mediaInfo.region,
		'authKey':		mediaInfo.auth_key,
		'beatInterval': mediaInfo.beatInterval,
		'url': mediaInfo.url
		},
		registerCallBacks: registerCallBacks
	});
}

function loadLivePlayer(mediaInfo){

 if(!document.querySelector('.instaPlayer')){
   console.error("Player container not found");
   return;
 }

 var playerConfig = new SaranyuInstaPlayer(mediaInfo.type, '.instaPlayer', {
   type: 'Video',
   content: 'VOD',

   file: [{
     content_url: mediaInfo.contenturl,
     encryption: mediaInfo.encryption || false,

     drm: {
       widevine: {
         LA_URL: mediaInfo.laurl || ''
       },
       fairplay: {
         CERT_URL: mediaInfo.certificate || '',
         LA_URL: mediaInfo.laurl || ''
       }
     },

     label: '',
     mediaid: '1A2B3C4D',

     videotitle:
       '<span style="font-weight:600;font-family:Roboto,Arial,sans-serif;">Now Playing:</span> ' +
       mediaInfo.title,

     poster: mediaInfo.poster,
     seekonload: Number(mediaInfo.seekonload || 0),
     thumbnails: mediaInfo.thumbnails || ''
   }],

   autoplay: mediaInfo.autoplay === true || mediaInfo.autoplay === 'true',

   live: true,
   mute: false,

   hideControlsWhenInactive: true,
   hideControlsTimeout: 5000,

   qualityswitch: {
     label: 'auto',
     metric: 'resolution'
   },

   features: [
     'backbutton','title','playpause','bigicons','volume',
     'subtitles','multiaudio','qualityswitch','fullscreen',
     'encryption','eventcallbacks','loadcallbacks'
   ],

   heartBeat: {
     catalogID: mediaInfo.catalog_id,
     contentID: mediaInfo.content_id,
     region: mediaInfo.region,
     authKey: mediaInfo.auth_key,
     beatInterval: 30,
     url: ''
   },

   registerCallBacks: registerCallBacks
 });

}
function loadBannerPlayer(mediaInfo){
	var playerConfig = new SaranyuInstaPlayer(mediaInfo.type, '.instaPlayer', {
		'type': 'banner',
		'content': 'VOD',
		'file': [{
		'content_url': mediaInfo.contenturl,
		'encryption': 'undefined' == mediaInfo.encryption ? false : mediaInfo.encryption,
		'drm': {
			'widevine': {
			'LA_URL': 	'undefined' == mediaInfo.laurl ? '' : mediaInfo.laurl
			},
			'fairplay': {
			'CERT_URL': 'undefined' == mediaInfo.certificate ? '' : mediaInfo.certificate,
			'LA_URL': 	'undefined' == mediaInfo.laurl ? '' : mediaInfo.laurl
			}
		},
		'label': '',
		'mediaid': '1A2B3C4D',
		'videotitle': mediaInfo.title,
		'poster': mediaInfo.poster,
		'seekonload': Number(mediaInfo.seekonload)
		}],
		'autoplay': eval(mediaInfo.autoplay),
		'mute': true,
		'hideControlsWhenInactive': true,
		'hideControlsTimeout': 5000,
		'qualityswitch': {
		'label': 'auto',
		'metric': 'resolution'
		},
		'advertisement': mediaInfo.adConfig,
		//'features': ['backbutton', 'title', 'playpause', 'backwardSeek', 'forwardSeek', 'bigicons', 'progressbar', 'volume', 'time', 'cast', 'subtitles', 'multiaudio', 'qualityswitch', 'fullscreen', 'encryption', 'hotkeys', 'eventcallbacks', 'loadcallbacks','advertisement'],
		'features': ['volume', 'cast', 'multiaudio', 'encryption', 'eventcallbacks', 'loadcallbacks','advertisement'],
		// 'heartBeat': {
		// 'catalogID': 	mediaInfo.catalog_id,
		// 'contentID': 	mediaInfo.content_id,
		// 'region': 		mediaInfo.region,
		// 'authKey':		mediaInfo.auth_key,
		// 'beatInterval': 5,
		// 'url': mediaInfo.url
		// },
		registerCallBacks: registerCallBacks
	});
}


function destroyPlayer(){
	// InstaPlayer._destroyMedia();
}

// FIRES WHEN EVENTS ARE DISPATCHED
registerCallBacks = function() {
	if(InstaPlayer.eventcallbacks) {
		InstaPlayer.eventcallbacks.onPlay = function(presentTime, duration, mediaId) {
      console.log("onPlay Fired (CB)");
      window.parent.postMessage("onPlay", "*");
		};
		InstaPlayer.eventcallbacks.onPause = function(presentTime, duration, mediaId) {
			console.log("onPause Fired (CB)");
			window.parent.postMessage("onPause", "*");
		};
		InstaPlayer.eventcallbacks.onResume = function(presentTime, duration, mediaId) {
			console.log("onResume Fired (CB)");
			window.parent.postMessage("onResume", "*");
		}
		InstaPlayer.eventcallbacks.onBackwardSeek = function(pastTime, presentTime, duration, mediaId) {
			console.log("Backward Seek (CB), Seek from: "+pastTime+" Seek to: "+presentTime);
			window.parent.postMessage({event_id: 'onPlaybackTime', data: { 'playback_time': presentTime, duration: duration }});
		};
		InstaPlayer.eventcallbacks.onForwardSeek = function(pastTime, presentTime, duration, mediaId) {
			console.log("Forward Seek (CB), Seek from: "+pastTime+" Seek to: "+presentTime);
			window.parent.postMessage({event_id: 'onPlaybackTime', data: { 'playback_time': presentTime, duration: duration }});
		};
		InstaPlayer.eventcallbacks.onSeeked = function(pastTime, presentTime, duration, mediaId) {
			console.log("onSeeked Fired (CB)");
			window.parent.postMessage({event_id: 'onPlaybackTime', data: { 'playback_time': presentTime, duration: duration }});
		};
		InstaPlayer.eventcallbacks.onComplete = function(presentTime, duration, mediaId) {
			console.log("onComplete Fired (CB)");
			window.parent.postMessage("onCompletePlayer", "*");
    	};
		InstaPlayer.eventcallbacks.onBeat = function(playbackTime) {
		// console.log("Playback Time:", playbackTime);
		window.parent.postMessage({event_id: 'onPlaybackTime', data: { 'playback_time': playbackTime }});
		// you will get current player duration in this playbackTime variable in HH:MM:SS format (ex. 00:00:50) like this.
		}
		InstaPlayer.eventcallbacks.onBuffering = function(presentTime, duration, mediaId) {
			console.log("Buffering Started (CB)");
			window.parent.postMessage({event_id: 'onBuffering', data: { playback_time: presentTime, duration: duration }}, '*');
		};
		InstaPlayer.eventcallbacks.watchlaterFailure = function() {
			window.parent.postMessage("watchlaterFailure", "*");
		}
		// InstaPlayer.eventcallbacks.onBack = function() {
		// 	console.log("Back Button Pressed (CB)");
			
		// };
		InstaPlayer.eventcallbacks.onNextEpisode = function() {
			window.parent.postMessage("onNextEpisode", "*");
			console.log("Next Episode Callback");
		};
		InstaPlayer.eventcallbacks.onPrevEpisode = function() {
			window.parent.postMessage("onPrevEpisode", "*");
			console.log("Next Episode Callback");
		};
		InstaPlayer.eventcallbacks.onError = function(type, code) {
			console.log(type, code);
			switch (code) {
				case 25:
					console.log("DASH Manifest Download Failed");
					break;
				case 26:
					console.log("FairPlay Video Generic Error");
					break;
				case 27:
					console.log("DASH Segment Loading Failed");
					break;
				case 111:
					console.log("No Widevine License Server URL Specified");
					break;
				case 114:
					console.log("Widevine DRM License Error");
					break;
				case 115:
					console.log("FairPlay DRM License Error");
					break;
			}
		}
		InstaPlayer.eventcallbacks.onBack = function () {
			console.log("Back Button Pressed (CB)");
			window.parent.postMessage("onBack", "*");
			window.history.go(-1);
	 	};
	}
	return
}
// FIRES WHEN PLAYER LOAD IS COMPLETE
playerLoadedCallback = function() {
	console.log("Saranyu Insta Player Loaded (CB)");
	window.parent.postMessage("playerLoaded", "*");
}
// START PLAYBACK
function startPlayback() {
	ME.play();
}
// LISTEN MESSAGE FOR PLAYBACK START
window.addEventListener("message", (event) => {
  if (event.data == "startPlayback") {
	  startPlayback();
  } else if(event.data == "banner_pause") {
	ME.pause();
  }
//   else if(event.data == "currentTime"){
// 	console.log('ME.currentTime:',ME.currentTime);
// 	return ME.currentTime

//   }
});


